import React from 'react';
import { motion } from 'framer-motion';

const Map = () => {
  // Coordinates for 14 Ada-George Road, Port Harcourt
  const address = "14 Ada-George Road, Port-Harcourt City, Rivers State, Nigeria";
  
  // Using a standard embed for demonstration
  const standardEmbed = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3975.807865225134!2d6.974411174980005!3d4.809413995166291!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1069ce66099b2f61%3A0x6b14d3f3f3f3f3f3!2sAda-George%20Rd%2C%20Port%20Harcourt!5e0!3m2!1sen!2sng!4v1700000000000!5m2!1sen!2sng";

  return (
    <motion.div 
      initial={{ opacity: 0, scale: 0.98 }}
      whileInView={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.8 }}
      className="w-full h-[400px] md:h-[450px] lg:h-[500px] rounded-2xl overflow-hidden shadow-2xl border-4 border-white dark:border-gray-800 relative z-10"
    >
      <iframe
        title="SSC Location Map"
        src={standardEmbed}
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        className="grayscale hover:grayscale-0 transition-all duration-700"
      ></iframe>
    </motion.div>
  );
};

export default Map;